import { Clock, SearchX, Truck, AlertTriangle, Fuel, ClipboardList, PackageSearch } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const PAINS = [
  { icon: SearchX, text: "Difficile de savoir ce qu'il reste dans les casiers" },
  { icon: PackageSearch, text: "Petites pièces impossibles à compter une par une" },
  { icon: Truck, text: "Stock du véhicule difficile à contrôler" },
  { icon: AlertTriangle, text: "Risque de manquer d'une pièce en plein chantier" },
  { icon: Fuel, text: "Déplacements inutiles chez le fournisseur" },
  { icon: Clock, text: "Du temps passé à vérifier les casiers un par un" },
  { icon: ClipboardList, text: "Consommables utilisés sans suivi précis" },
];

export default function Problem() {
  return (
    <section id="probleme" className="py-16 sm:py-24" data-testid="problem-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Le problème</Eyebrow>
          <SectionTitle>Combien de temps perdez-vous à vérifier votre stock ?</SectionTitle>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PAINS.map((p, i) => (
            <Reveal key={p.text} delay={i * 0.06}>
              <div className="h-full border border-[#2E333D] bg-[#141619] rounded-xl p-6 hover:border-[#FFC700]/40 transition-colors" data-testid={`problem-card-${i}`}>
                <p.icon size={22} className="text-[#FFC700] mb-4" />
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.42}>
            <div className="h-full border border-[#FFC700]/50 bg-[#FFC700]/5 rounded-xl p-6 flex items-center">
              <p className="font-display text-xl sm:text-2xl font-bold uppercase text-[#FFC700] leading-tight">
                Vous savez ce qu'il vous reste. Vous savez ce qu'il vous manque.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
